export var LOGOUT_PATH = '/logout';
